import { PricingRadio } from 'components/PricingRadio/PricingRadio';
import s from './PricingBar.module.css';

export const PricingBar = props => {
  const { avatar, name, isRadio, price, slug } = props['company'];
  const total = props['total'];
  const onClck = props['onClick'];

  let priceArray = null;

  if (typeof price.storage !== 'number') {
    priceArray = Object.keys(price.storage);
  }

  return (
    <div className={s.column} onClick={onClck}>
      <span className={s.tooltip}>
        <span className={s.tooltipLog}>{total}</span> $
      </span>

      <div style={{ height: `${total / 1.8}rem` }} className={s.fill}></div>

      <div className={`${s.logo} ${isRadio ? '' : s.mb2}`}>
        <a href={slug} target="blank">
          <img className={s.img} src={avatar} alt="" />
        </a>

        <div className={s.label}>{name}</div>
      </div>

      {isRadio && priceArray ? (
        <PricingRadio
          name={name.toLowerCase()}
          value1={priceArray[0]}
          value2={priceArray[1]}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
